import { useMemo } from "react";
import { useDashboardData } from "../hooks/useDashboardData";
import { useFavoritos } from "../hooks/useFavoritos";
import { parseDataPedido } from "../utils/metricas";
import { normalizarStatus } from "../constants/statusPedido";
import { SkeletonCard } from "./ui/Skeleton";
import { I, IC, MAIS_ITEMS } from "../constants/nav";
import { CalcIcon } from "./calculadora/CalcIcon";
import "./mobileNavigation.css";

const QUICK_ACTIONS = [
  { id:"calc", label:"Calcular preço", icon:IC.calc, color:"#65e5cb" },
  { id:"pedidos", label:"Pedidos", icon:IC.orders, color:"#8bbfff" },
  { id:"caixa", label:"Abrir PDV", icon:IC.cart, color:"#ffc48e" },
  { id:"fila", label:"Produção", icon:IC.printer, color:"#c7b1ff" },
];
function dataDe(item) {
  const value = item?.created_at;
  if (!value) return null;
  try { return value.toDate ? value.toDate() : new Date(value); } catch { return null; }
}
function dataRelativa(date) {
  if (!date || !Number.isFinite(date.getTime())) return "";
  const days = Math.floor((Date.now() - date.getTime()) / 86400000);
  return days <= 0 ? "hoje" : days === 1 ? "ontem" : `há ${days}d`;
}
function saudacao() {
  const h = new Date().getHours();
  return h < 12 ? "Bom dia" : h < 18 ? "Boa tarde" : "Boa noite";
}

// A operação fica no topo; os indicadores financeiros por período ficam no Dashboard.
export default function HomeMobileExtras({ perfil, clientesGlobal, onGoTab, onAbrirBusca }) {
  const { pedidos, filamentos, materiais, produtos, fila, loading } = useDashboardData();
  const { favoritos } = useFavoritos();
  const summary = useMemo(() => {
    const filBaixos = filamentos.filter(f => parseFloat(f.peso) > 0 && f.peso_restante != null && parseFloat(f.peso_restante) / parseFloat(f.peso) < 0.2).length;
    const matBaixos = materiais.filter(m => m.alerta_baixo !== false && (parseFloat(m.quantidade) || 0) < (parseFloat(m.limite_alerta) || 10)).length;
    return [
      { label:"Pedidos ativos", value:pedidos.filter(p => !["entregue", "cancelado"].includes(normalizarStatus(p.status))).length },
      { label:"Estoque baixo", value:filBaixos + matBaixos },
      { label:"Novos clientes · 7d", value:(clientesGlobal || []).filter(c => c.criadoEm && new Date(c.criadoEm).getTime() >= Date.now() - 7 * 86400000).length },
    ];
  }, [pedidos, filamentos, materiais, clientesGlobal]);
  const recent = useMemo(() => [
    { id:"pedidos", label:"Último pedido", icon:IC.orders, list:pedidos, date:parseDataPedido, name:item => item.produto },
    { id:"produtos", label:"Último produto", icon:IC.box, list:produtos, date:dataDe, name:item => item.nome },
    { id:"filamentos", label:"Último filamento", icon:IC.spool, list:filamentos, date:dataDe, name:item => item.cor || item.nome },
    { id:"fila", label:"Última impressão", icon:IC.printer, list:fila, date:parseDataPedido, name:item => item.produto || item.nome },
  ].map(row => ({ ...row, item:[...row.list].sort((a,b) => (row.date(b)?.getTime() || 0) - (row.date(a)?.getTime() || 0))[0] })).filter(row => row.item), [pedidos, produtos, filamentos, fila]);
  const pinned = MAIS_ITEMS.filter(item => favoritos.includes(item.id));
  const name = (perfil?.nome || "").split(" ")[0];
  const recentButton = row => <button type="button" key={row.id} onClick={() => onGoTab(row.id)}>
    <I d={row.icon} s={20} c="#91bcb9" />
    <span><strong>{row.name(row.item) || row.label}</strong><small>{row.label} · {dataRelativa(row.date(row.item))}</small></span>
    <CalcIcon name="chevron" size={16} />
  </button>;
  return <div className="mobile-home">
    <header className="mobile-home-hero">
      <span className="mobile-eyebrow">SEU DIA EM UM SÓ LUGAR</span>
      <h1>{saudacao()}{name ? `, ${name}` : ""}.</h1>
      <p>Vamos dar vida à próxima ideia?</p>
      <button type="button" className="mobile-home-search" onClick={onAbrirBusca}><CalcIcon name="search" />Buscar pedidos, clientes e produtos</button>
    </header>
    <section aria-label="Acesso rápido">
      <h2 className="mobile-home-section-title">O que vamos fazer?</h2>
      <div className="mobile-home-actions">{QUICK_ACTIONS.map(action => <button type="button" key={action.id} className="mobile-home-action" style={{ "--action-color":action.color }} onClick={() => onGoTab(action.id)}>
        <span><I d={action.icon} s={20} /></span><strong>{action.label}</strong>
      </button>)}</div>
    </section>
    {pinned.length > 0 && <section aria-label="Seus atalhos"><h2 className="mobile-home-section-title">Seus atalhos</h2><div className="mobile-home-favorites">{pinned.map(item => <button type="button" key={item.id} onClick={() => onGoTab(item.id)}><I d={item.icon} s={16} />{item.label}</button>)}</div></section>}
    <section aria-label="Sua operação"><h2 className="mobile-home-section-title">Sua operação</h2>
      {loading ? <SkeletonCard rows={1} /> : <div className="mobile-home-metrics">{summary.map(metric => <div className="mobile-home-metric" key={metric.label}><strong>{metric.value}</strong><span>{metric.label}</span></div>)}</div>}
    </section>
    {!loading && recent.length > 0 && <section aria-label="Atividade recente"><h2 className="mobile-home-section-title">Retome o trabalho</h2><div className="mobile-home-recent">
      {recent.slice(0,2).map(recentButton)}
      {recent.length > 2 && <details><summary>Ver mais atividades</summary><div className="mobile-home-recent">{recent.slice(2).map(recentButton)}</div></details>}
    </div></section>}
  </div>;
}
